import { useEffect } from "react";
import { Header } from "@/components/Header";
import { MobileStickyCTA } from "@/components/MobileStickyCTA";
import { Footer } from "@/components/Footer";
import { Hero } from "@/sections/Hero";
import { EditorialMarquee } from "@/sections/Marquee";
import { Impact } from "@/sections/Impact";
import { NoiseExplainer } from "@/sections/NoiseExplainer";
import { Emotion } from "@/sections/Emotion";
import { Comparison } from "@/sections/Comparison";
import { TrajectoryMap } from "@/sections/TrajectoryMap";
import { Asphalt } from "@/sections/Asphalt";
import { Why80 } from "@/sections/Why80";
import { FAQ } from "@/sections/FAQ";
import { Sources } from "@/sections/Sources";
import { Contact } from "@/sections/Contact";
import { FinalCTA } from "@/sections/FinalCTA";
import { track } from "@/lib/analytics";

const Home = () => {
  useEffect(() => {
    track("page_view", { page: "home" });
    const marks = [25, 50, 75, 100];
    const fired = new Set();
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? Math.round((window.scrollY / max) * 100) : 100;
      marks.forEach((m) => {
        if (pct >= m && !fired.has(m)) {
          fired.add(m);
          track("scroll_depth", { scroll_depth: m, page: "home" });
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Impact />
        <NoiseExplainer />
        <Emotion />
        <Comparison />
        <TrajectoryMap />
        <Asphalt />
        <Why80 />
        <FAQ />
        <Sources />
        <Contact />
        <FinalCTA />
      </main>
      <Footer />
      <MobileStickyCTA />
    </>
  );
};

export default Home;
